import { ICourse } from 'interface/course';
import { useEffect } from 'react';
import ReactGA from 'react-ga';

export const useGoogleAnalytics = (course: ICourse) => {
  useEffect(() => {
    if (!course || !course.gl_analytics) return;
    ReactGA.initialize(course.gl_analytics);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [course]);
};
